import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TheaterIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M3.096 4a1 1 0 100 2h18a1 1 0 100-2h-18zM3.55 15.253a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM7.148 13.75a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM11.148 13.75a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM15.55 15.253a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM19.148 13.75a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM1.55 19.453a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM9.148 17.95a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM13.148 17.95a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM17.55 19.453a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM21.148 17.95a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM5.148 17.95a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM5.646 11.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM9.646 11.053a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM13.646 11.053a1.1 1.1 0 111.1-1.906 1.1 1.1 0 01-1.1 1.906zM17.243 9.55a1.1 1.1 0 101.906 1.1 1.1 1.1 0 00-1.906-1.1z"
                    })
                })
            })
        ]
    });
};
TheaterIcon.isCarinaIcon = true;
export default TheaterIcon;
